import { useTacoConfigParameter } from '@coursera-web/taco-config-client';

import type { ChatTargetingRule } from 'bundles/common/utils/chatLoaderUtils';

type ChatConfigType = {
  enabledLanguages?: string[];
  targetingRules: ChatTargetingRule[];
};

type BoostChatParameters = {
  enableChat: boolean;
  chatBoostInstanceName: string;
  chatConfig: ChatConfigType;
};

export const TACO_NAMESPACE_BOOST_CHAT = 'boost-support-chat/v1/config';

const useBoostChatConfig = () => {
  const { data: parameters, loading } = useTacoConfigParameter<BoostChatParameters>(
    TACO_NAMESPACE_BOOST_CHAT,
    'parameters'
  );

  const enableChat = parameters?.enableChat ?? false;
  const chatConfig = parameters?.chatConfig;
  const boostInstanceName = parameters?.chatBoostInstanceName || '845coursera';

  return {
    enableChat,
    chatConfig,
    boostInstanceName,
    loading,
    configValues: {
      enableChat,
      chatBoostInstanceName: boostInstanceName,
      chatConfig,
    } as Record<string, unknown>,
  };
};

export type BoostChatConfig = ReturnType<typeof useBoostChatConfig>;

export default useBoostChatConfig;
